/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import {
  getAllStore,
  searchStoretByNameOrCategory,
  getCategory,
  getMyProduct,
  getStoreInfoById,
} from '../../../utils/services/user.service';
import StoreCard from './components/StoreCard';
import StoreEditor from './components/StoreEditor';
import StoreView from './components/StoreView';
import ProductView from './components/ProductView';
import AuctionView from './components/AuctionView';
import DeleteConfirmModal from './components/DeleteConfirmModal';

// Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
//   background: #0b0f14;
  color: white;
  padding: 2.5rem;
  position: relative;
  z-index: 0;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;
  position: sticky;
  top: 0;
//   background: rgba(11, 15, 20, 0.8);
  backdrop-filter: blur(10px);
  z-index: 1;
  padding-bottom: 1rem;
`;

const HeaderTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 600;
  margin: 0;
`;

const HeaderSubtitle = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin: 0;
`;

const NewStoreButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  color: black;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

const MyStoresButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 0.75rem;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: #5ce9ff;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const SearchSection = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.75rem;
  border-radius: 0.5rem;
  color: white;
  
  &::placeholder {
    color: #9ca3af;
  }
  
  &:focus {
    outline: none;
    border-color: #5ce9ff;
  }
`;

const CategorySelect = styled.select`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.75rem;
  border-radius: 0.5rem;
  color: white;
  
  &:focus {
    outline: none;
    border-color: #5ce9ff;
  }
  
  option {
    background: #0B1122;
    color: white;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5rem 0;
`;

const Spinner = styled.div`
  width: 3rem;
  height: 3rem;
  border: 2px solid transparent;
  border-top: 2px solid #5ce9ff;
  border-bottom: 2px solid #5ce9ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const StoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 5rem 0;
  
  p {
    color: #9ca3af;
    font-size: 1.125rem;
  }
`;

export default function StoreGallery() {
  const history = useHistory();
  const user = JSON.parse(localStorage?.getItem('user'));
  const userRole = user?.data?.user?.role || 'viewer';
  
  const [stores, setStores] = useState([]);
  const [filteredStores, setFilteredStores] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  // UI States
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [viewStore, setViewStore] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [viewAuction, setViewAuction] = useState(null);
  
  // Filters for store view
  const [filterCategory, setFilterCategory] = useState('all');
  const [filterCertified, setFilterCertified] = useState(false);
  const [filterStock, setFilterStock] = useState(false);

  // Permissions
  const canCreate = userRole === 'admin';
  const canEdit = userRole === 'admin' || userRole === 'seller';
  const canDelete = userRole === 'admin';
  const canPublish = userRole === 'admin' || userRole === 'compliance';

  // Fetch stores
  const fetchStores = async () => {
    try {
      setIsLoading(true);
      const requestData = {
        limit: 50,
        pageNumber: currentPage,
      };
      const response = await getAllStore(requestData);
      console.log("🚀 ~ fetchStores ~ response:", response)
      
      if (response.data?.result) {
        const storesData = response.data.result.map(store => ({
          id: store._id,
          name: store.storeName,
          slug: store.storeName?.toLowerCase().replace(/\s+/g, '-'),
          shortDescription: store.storeDescription || 'No description available',
          category: store.store_category_id || null,
          role: store.store_type || 'standard',
          status: store.status === 'approved' ? 'published' : 'draft',
          coverImage: store.storeLogo,
          logo: store.storeLogo,
          storeOwnerId: store.storeOwnerId,
          rating: store.Store_avg_ratting || 0,
          originalData: store,
        }));
        
        // Filter out user's own stores
        const filtered = storesData.filter(
          (item) => item?.storeOwnerId !== user?.data?.user?.user_id
        );
        
        setStores(storesData);
        setFilteredStores(storesData);
      }
    } catch (error) {
      console.error('Error fetching stores:', error);
      toast.error('Failed to load stores');
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const response = await getCategory();
      if (response.data?.category) {
        setCategories(response.data.category);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  useEffect(() => {
    fetchStores();
    fetchCategories();
  }, [currentPage]);

  // Search stores
  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      fetchStores();
      return;
    }

    try {
      setIsLoading(true);
      const requestData = {
        store_name: searchTerm,
        sub_category_id: selectedCategory?._id || '',
        pageNumber: 1,
        limit: 50,
      };
      
      const response = await searchStoretByNameOrCategory(requestData);
      
      if (response.data?.result) {
        const storesData = response.data.result.map(store => ({
          id: store._id,
          name: store.storeName,
          slug: store.storeName?.toLowerCase().replace(/\s+/g, '-'),
          shortDescription: store.storeDescription || 'No description available',
          category: store.store_category_id || null,
          role: store.store_type || 'standard',
          status: store.status === 'approved' ? 'published' : 'draft',
          coverImage: store.storeLogo,
          logo: store.storeLogo,
          storeOwnerId: store.storeOwnerId,
          rating: store.Store_avg_ratting || 0,
          originalData: store,
        }));
        
        const filtered = storesData.filter(
          (item) => item?.storeOwnerId !== user?.data?.user?.user_id
        );
        
        setFilteredStores(storesData);
      } else {
        setFilteredStores([]);
      }
    } catch (error) {
      console.error('Error searching stores:', error);
      toast.error('Search failed');
    } finally {
      setIsLoading(false);
    }
  };

  // Handle category filter
  const handleCategoryClick = async (category) => {
    if (!category) {
      fetchStores();
      setSelectedCategory(null);
      return;
    }

    try {
      setIsLoading(true);
      setSelectedCategory(category);
      const requestData = {
        store_name: '',
        category_id: category._id,
        pageNumber: 1,
        limit: 50,
      };
      
      const response = await searchStoretByNameOrCategory(requestData);
      
      if (response.data?.result) {
        const storesData = response.data.result.map(store => ({
          id: store._id,
          name: store.storeName,
          slug: store.storeName?.toLowerCase().replace(/\s+/g, '-'),
          shortDescription: store.storeDescription || 'No description available',
          category: store.store_category_id || null,
          role: store.store_type || 'standard',
          status: store.status === 'approved' ? 'published' : 'draft',
          coverImage: store.storeLogo,
          logo: store.storeLogo,
          storeOwnerId: store.storeOwnerId,
          rating: store.Store_avg_ratting || 0,
          originalData: store,
        }));
        
        const filtered = storesData.filter(
          (item) => item?.storeOwnerId !== user?.data?.user?.user_id
        );
        
        setFilteredStores(storesData);
      }
    } catch (error) {
      console.error('Error filtering by category:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Open new store editor
  const openNew = () => {
    history.push('/createstore');
  };

  // Open edit store
  const openEdit = (store) => {
    history.push(`/editstore?id=${store.id}`);
  };

  // View store details
  const handleViewStore = async (store) => {
    console.log("🚀 ~ handleViewStore ~ store:", store)
    history.push(`/storedetail/${store.id}`);

    // try {
    //   setIsLoading(true);
    //   const response = await getStoreInfoById({ store_id: store.id });
      
    //   if (response.data?.result) {
    //     const storeData = response.data.result[0];
    //     const productsResponse = await getMyProduct({
    //       limit: 50,
    //       pageNumber: 1,
    //       store_id: store.id,
    //     });
        
    //     const products = productsResponse.data?.products || [];
        
    //     setViewStore({
    //       ...store,
    //       originalData: storeData,
    //       products: products.map(p => ({
    //         id: p._id,
    //         name: p.productName,
    //         price: p.productPrice,
    //         certified: p.isCertified || false,
    //         stock: p.productStock > 0,
    //         category: p.product_category_id?.category_name || 'General',
    //         image: p.productImages?.[0] || 'https://images.unsplash.com/photo-1584017911766-d451b3d0e843',
    //         originalData: p,
    //       })),
    //       trace: storeData.traceabilityEvents || [],
    //     });
    //   }
    // } catch (error) {
    //   console.error('Error fetching store details:', error);
    //   toast.error('Failed to load store details');
    // } finally {
    //   setIsLoading(false);
    // }
  };

  // Soft delete store
  const handleSoftDelete = () => {
    if (!confirmDelete) return;
    
    // In a real implementation, you would call an API to soft delete
    setStores(prev => prev.filter(s => s.id !== confirmDelete.id));
    setFilteredStores(prev => prev.filter(s => s.id !== confirmDelete.id));
    setConfirmDelete(null);
    toast.success('Store deleted');
  };

  // Handle product view
  if (viewProduct) {
    return (
      <ProductView
        product={viewProduct}
        onBack={() => setViewProduct(null)}
      />
    );
  }

  // Handle auction view
  if (viewAuction) {
    return (
      <AuctionView
        auction={viewAuction}
        onBack={() => setViewAuction(null)}
      />
    );
  }

  // Handle store detail view
  if (viewStore) {
    return (
      <StoreView
        store={viewStore}
        onBack={() => setViewStore(null)}
        onProductClick={setViewProduct}
        onAuctionClick={setViewAuction}
        filterCategory={filterCategory}
        setFilterCategory={setFilterCategory}
        filterCertified={filterCertified}
        setFilterCertified={setFilterCertified}
        filterStock={filterStock}
        setFilterStock={setFilterStock}
        userRole={userRole}
      />
    );
  }

  // Main store gallery view
  return (
    <PageContainer>
      {/* Header */}
      <HeaderSection>
        <div>
          <HeaderTitle>Stores</HeaderTitle>
          <HeaderSubtitle>Verified partners on Custodiy Marketplace</HeaderSubtitle>
        </div>
        <ButtonGroup>
          <MyStoresButton onClick={() => history.push('/storedetail')}>
            My Stores
          </MyStoresButton>
          {/* {canCreate && (
            <NewStoreButton onClick={openNew}>
              + New Store
            </NewStoreButton>
          )} */}
        </ButtonGroup>
      </HeaderSection>

      {/* Loading State */}
      {isLoading && (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      )}

      {/* Store Grid */}
      {!isLoading && (
        <StoreGrid>
          {filteredStores
            .filter(s => userRole !== 'viewer' || s.status === 'published')
            .map(store => (
              <StoreCard
                key={store.id}
                store={store}
                onView={() => handleViewStore(store)}
                onEdit={canEdit ? () => openEdit(store) : null}
                onDelete={canDelete ? () => setConfirmDelete(store) : null}
              />
            ))}
        </StoreGrid>
      )}

      {/* Empty State */}
      {!isLoading && filteredStores.length === 0 && (
        <EmptyState>
          <p>No stores available.</p>
        </EmptyState>
      )}

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        store={confirmDelete}
        onConfirm={handleSoftDelete}
        onCancel={() => setConfirmDelete(null)}
      />
    </PageContainer>
  );
}

